module.exports = __webpack_public_path__ + "img/009.8aa1c453.jpg";